import { IApplicationState } from '../../types/redux';

export const selectMapData = (state: IApplicationState) => state.map.data;
